const AuditLog = {
    // FIELDS
    "user": "User",
    "from_date": "From Date",
    "to_date": "To Date",
    "search": "Search",

    // PAGE HEADER
    "audit_log": "Audit Log",

    // TABLE HEADERS
    "table_date": "DATE & TIME",
    "table_user": "USER",
    "table_module": "MODULE",
    "table_action": "ACTION",
    "table_description": "DESCRIPTION",
}

export default AuditLog;
